import { useState } from "react";
import "../Style/appdevprocess.css";

import swotImage from "../assets/iPhone.png";
import flowImage from "../assets/CMD.png";
import wireframesImage from "../assets/image.png";
import dashboardImage from "../assets/appdesi.png";
import uxUiImage from "../assets/group (2).png";
import deloyeImage from "../assets/CMDS.png";
import postImage from "../assets/appdesi.png";
import markImage from "../assets/appdesign.png";

const stepsData = [
  {
    title: "Idea & Requirement Analysis",
    description:
      "Every successful mobile application starts with understanding your business goals. We analyze your idea, identify user needs, research competitors, and define the core features required to build a scalable, market-ready mobile app that delivers real business value.",
    image: swotImage,
  },

  {
    title: "Project Planning & Strategy",
    description:
      "After validating your idea, we prepare a complete development roadmap. Our team selects the right technology stack, defines project milestones, creates user flows, and plans the architecture to ensure efficient development and long-term scalability.",
    image: flowImage,
  },

  {
    title: "UI/UX Design & Interactive Prototyping",
    description:
      "Our UI/UX designers create intuitive, visually engaging interfaces that deliver exceptional user experiences. We develop wireframes, interactive prototypes, and modern app designs to validate user flows, improve usability, and ensure the application reflects your brand before development begins.",
    image: wireframesImage,
  },

  {
    title: "Mobile App Development",
    description:
      "Once the design is approved, our developers transform concepts into a powerful mobile application using modern technologies. We build secure, scalable Android, iOS, and cross-platform apps with clean code, API integrations, optimized performance, and robust backend architecture for seamless functionality.",
    image: dashboardImage,
  },

  {
    title: "Quality Assurance & App Testing",
    description:
      "Before launch, every mobile application undergoes comprehensive quality assurance testing to ensure flawless performance. We perform functional, usability, security, compatibility, and performance testing to identify and resolve issues, delivering a stable, secure, and user-friendly mobile app across all devices.",
    image: uxUiImage,
  },

  {
    title: "App Deployment & Store Publishing",
    description:
      "Once testing is complete, we deploy your mobile application to the Google Play Store and Apple App Store following all platform guidelines. Our team manages the submission process, optimizes store listings, and ensures a smooth, successful launch with minimal downtime and maximum reliability.",
    image: deloyeImage,
  },

  {
    title: "Post-Launch Support & App Maintenance",
    description:
      "Launching your app is only the beginning. We provide continuous app maintenance, security updates, performance monitoring, bug fixes, feature enhancements, and technical support to ensure your mobile application remains secure, reliable, and compatible with the latest Android and iOS updates.",
    image: postImage,
  },

  {
    title: "App Marketing & Growth Strategy",
    description:
      "To maximize your app's success, we help improve visibility through App Store Optimization (ASO), digital marketing strategies, and user engagement campaigns. Our approach focuses on increasing app downloads, improving user retention, and driving long-term business growth with data-driven marketing insights.",
    image: markImage,
  },
];

export default function Appdesign() {
  const [currentStep, setCurrentStep] = useState(0);
  const [direction, setDirection] = useState("next");

  const nextStep = () => {
    if (currentStep < stepsData.length - 1) {
      setDirection("next");
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setDirection("prev");
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <section className="appdevprocess-section">
      <div className="appdevprocess-container">

        {/* TITLE */}

        <h2 className="appdevprocess-title">
          Our Mobile App Development Process
        </h2>

        <p className="appdevprocess-subtitle">
          From Idea to Launch — Building Scalable, User-Centric Mobile Applications
        </p>

        {/* CONTENT */}

        <div className="appdevprocess-content">

          {/* LEFT SIDE STEPS */}

          <div className="appdevprocess-steps">

            {stepsData.map((step, index) => (

              <p
                key={index}
                className={
                  index === currentStep
                    ? "appdevprocess-step-item appdevprocess-step-item-active"
                    : "appdevprocess-step-item"
                }
              >
                {index + 1}. {step.title}
              </p>

            ))}

          </div>

          {/* DETAILS */}

          <div className="appdevprocess-details">

            <h3 className="appdevprocess-details-title">
              {stepsData[currentStep].title}
            </h3>

            <div className="appdevprocess-description-box">
              <p>{stepsData[currentStep].description}</p>
            </div>

            {/* SLIDER */}

            <div className="appdevprocess-slider">

              <button
                onClick={prevStep}
                className="appdevprocess-nav-btn"
                disabled={currentStep === 0}
              >
                {"<"}
              </button>

              {/* DOTS */}

              <div className="appdevprocess-dots">

                {stepsData.map((_, i) => (

                  <span
                    key={i}
                    className={
                      i === currentStep
                        ? i === stepsData.length - 1
                          ? "appdevprocess-dot appdevprocess-dot-active appdevprocess-dot-last"
                          : "appdevprocess-dot appdevprocess-dot-active"
                        : "appdevprocess-dot"
                    }
                  />

                ))}

              </div>

              <button
                onClick={nextStep}
                className="appdevprocess-nav-btn"
                disabled={currentStep === stepsData.length - 1}
              >
                {">"}
              </button>

            </div>

            {/* BUTTONS */}

            <div className="appdevprocess-cta">
              <a
                href="tel:+919876543210"
                className="appdevprocess-btn-ghost"
              >
                <button className="appdevprocess-btn-primary">
                  Let's Build Together ↗
                </button>
              </a>
              <a
                href="tel:+919876543210"
                className="appdevprocess-btn-ghost"
              >
                <button className="appdevprocess-btn-ghost">
                  Free consultation

                  <span className="appdevprocess-arrow-icon">
                    ↗
                  </span>
                </button>
              </a>

            </div>

          </div>

          {/* IMAGE */}

          <div className="appdevprocess-image-wrapper">

            <div className="appdevprocess-image-frame">

              <img
                key={currentStep}
                src={stepsData[currentStep].image}
                alt={stepsData[currentStep].title}
                className={`appdevprocess-moving-image ${direction === "next"
                  ? "appdevprocess-slide-left"
                  : "appdevprocess-slide-right"
                  }`}
              />

            </div>

          </div>

        </div>
      </div>
    </section>
  );
}